import Structor from "../util/structor"

export default class DateAnnotationCourseDefaultAttributes extends Structor {
  defineStruct() {
    this.field("rotationId")
    this.field("semesterId")
    this.field("isOff")
  }
}
